import React from 'react';
import SieveEditor from './components/SieveEditor';
import './index.css';

function App() {
    return (
        <div className="App">
            <SieveEditor />
        </div>
    );
}

export default App;